import { useLayoutEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { connectedUserSelector } from '../../user/selectors'
import { closeSocketServer, openSocketServer } from '../socketServerConnectionService'
import { ConnectedSocketUser } from '../types'
import { FeedbotThunk } from '../../types'
import { isSocketServerConnectedSelector } from '../selectors'
import { endpointHelpers } from '../../../features/serverBots/endpointHelpers'

const openConnectionThunk =
  (botId: string, user: ConnectedSocketUser): FeedbotThunk =>
  (dispatch, getState) =>
    openSocketServer(botId, user, dispatch, getState)

export const useSocketServerConnection = () => {
  const botId = useBotIdFromUrlFromUrl__HACK()
  const dispatch = useDispatch()
  const user = useSelector(connectedUserSelector)
  const userPermissionsQuery = endpointHelpers.getCurrentUserPermissionsForCurrentBot.useQuery()

  const userIdOrEmail = user.id || user.email
  const userRole = userPermissionsQuery?.data?.role
  const arePermissionsLoaded = userPermissionsQuery.isSuccess

  // useLayoutEffect triggers before useEffect
  useLayoutEffect(() => {
    if (botId && userRole && userIdOrEmail && arePermissionsLoaded) {
      dispatch(openConnectionThunk(botId, user))
    }

    if (!botId) {
      closeSocketServer()
    }
    // Prevent re-connecting on object ref change...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botId, userRole, userIdOrEmail, arePermissionsLoaded, dispatch])

  return {
    isConnected: useSelector(isSocketServerConnectedSelector)
  }
}

// This is not a
// Here we use it to speed up the initial load of Designer - we do not have to wait for:
// page component load -> loadedBotId dispatched and stored into state -> selectorRegistering it
// instead we grab it asap to save some millis of page load. Very niche use-case, use loadedBotId otherwise.
function useBotIdFromUrlFromUrl__HACK(): string | null {
  return useMemo(() => {
    const m = window.location.pathname.match(/^\/bots\/([^\/]+)/)
    return m ? m[1] : null
  }, [window.location.pathname])
}
